import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import LinkBox from '../../../components/common/header/LinkBox';
import * as authApi from '../../../lib/api/auth';

const LinkBoxContainer = () => {
  const [links, setLinks] = useState([]);
  const loading = links.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      try {
        const filterObject = {
          blcCd: 'BASE',
          mlcCd: 'HEADER',
          slcCd: 'LINKS',
          useYn: 'Y',
        };
        const response = await authApi.getBaseCode(filterObject);

        if (active) {
          const orderedList = _.orderBy(response.data.list, 'step');
          setLinks(orderedList);
        }
      } catch (err) {
        console.log(err);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return <LinkBox links={links} />;
};

export default LinkBoxContainer;
